import {
  CLEAR_SHELTER_DATA,
  LOAD_SHELTER_DATA,
  LOAD_SHELTER_DATA_SUCCESS,
  SAVE_SHELTER_DATA,
  ShelterDataActions,
} from '../../actions/shelter-actions/shelter-actions';

export const initialState = {
  loading: false,
  loaded: false,
  shelterId: null,
  columnDefs: [],
  rowData: [],
};

export function reducer(state = initialState, action: ShelterDataActions) {
  let payload: any;
  switch (action.type) {
    case SAVE_SHELTER_DATA:
      payload = action.payload;
      return {
        ...state,
        ...payload,
      };

    case LOAD_SHELTER_DATA:
      payload = action.payload;
      return {
        ...state,
        loaded: false,
        loading: true,
        shelterId: payload.shelterId,
      };

    case LOAD_SHELTER_DATA_SUCCESS:
      payload = action.payload;
      return {
        ...state,
        loaded: true,
        loading: false,
        ...payload,
      };

    case CLEAR_SHELTER_DATA:
      return {
        loaded: false,
        loading: false,
        shelterId: null,
        columnDefs: [],
        rowData: [],
      };

    default:
      return state;
  }
}
